import { render } from "./Kontakt.vue?vue&type=template&id=6977454e"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"

import "./Kontakt.vue?vue&type=style&index=0&id=6977454e&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__